import { ConsignmentNotificationListPage } from "@/features/consignment-notification/pages/ConsignmentNotificationListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-notification/")({
	component: ConsignmentNotificationListPage,
});
